import { defineMessages } from 'react-intl';

export default defineMessages({
  noVatNumber: { id: 'gofre.Document.Form.select.no-vat-number' },
});
